<script lang="ts" setup>
const { login: sanctumLogin } = useSanctumAuth();

definePageMeta({
    title: "Login",
    path: "/login",
});

useHead({
    title: "Login",
    bodyAttrs: {
        class: "bg-hd-base-original",
    },
});
</script>

<template>
    <UContainer class="flex items-center justify-center h-screen w-screen">
        <AuthLoginForm />
    </UContainer>
</template>
